/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSectionSign = createReactComponent("outline", "section-sign", "IconSectionSign", [["path", { "d": "M9.172 19a3 3 0 1 0 2.828 -4", "key": "svg-0" }], ["path", { "d": "M14.83 5a3 3 0 1 0 -2.83 4", "key": "svg-1" }], ["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }]]);

export { IconSectionSign as default };
//# sourceMappingURL=IconSectionSign.mjs.map
